<template>
  <div class="pool" :class="$bus.ComPool.status ? 'disabled': ''">
    <template v-for="(item, index) in $bus.ComPool.list">
      <Item class="item" :key="index" :imgSrc="item.thumb" :active="Status(item.id)" @handleItem="handleItem(item)">
        <template v-slot:mark>
          <div v-show="item.nums > 1" class="item-nums"><span>x</span><span>{{item.nums}}</span></div>
        </template>
      </Item>
    </template>
  </div>
</template>

<script>
import Item from '@/components/pool/item.vue'
export default {
  components: {
    Item
  },
  computed: {
    Status () {
      return id => {
        for (let item of this.$bus.selects) {
          if (item.id === id) {
            return 'active'
          }
        }
      }
    }
  },
  methods: {
    handleItem (item) {
      if (this.$bus.ComPool.status) { // 已经买过了
        return false
      }
      if (this.$bus.selects.indexOf(item) > -1) {
        this.$bus.selects.splice(this.$bus.selects.indexOf(item), 1)
        return false
      }
      if (this.$bus.selects.length >= 3) {
        return false
      } else {
        this.$bus.selects.push(item)
        this.$bus.addGA('prize_pool', 'selected')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.pool {
  @include flexrc;
  @include px2res(width, 1218);
  @include px2res(margin, 0, auto, 22);
  justify-content: space-between;
  .item {
    position: relative;
    .item-nums {
      color: #FFDE00;
      font-weight: 500;
      position: absolute;
      z-index: 3;
      @include px2res(top, 12);
      @include px2res(right, 22);
      @include px2res(font-size, 30);
    }
  }
}
.pool.disabled {
  filter: grayscale(100%);
}
</style>



// WEBPACK FOOTER //
// src/components/pool/index.vue